module.exports = __webpack_public_path__ + "img/home-user-xifen.252a8926.svg";